module.exports = __webpack_public_path__ + "media/public/img/operator-banner-77cef8984679f3a0a073007eee97678d.png";